import { UnitConverter } from '../utils/unitConverter';

export class DefaultProductParams {
	public height: number;
	public width: number;
	public depth: number;
	public height_compression_coef: number;
	public width_compression_coef: number;
	public depth_compression_coef: number;
	public weight: number;

	constructor() {
		this.height = UnitConverter.convertAndRoundToSaveValue(0.16);
		this.width = UnitConverter.convertAndRoundToSaveValue(0.08);
		this.depth = UnitConverter.convertAndRoundToSaveValue(0.08);
		this.height_compression_coef = 0;
		this.width_compression_coef = 0;
		this.depth_compression_coef = 0;
		this.weight = UnitConverter.getSaveConvertMassValue(1);
	}
}